import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { SvipUserInfoProps } from '@/views/user/member/service';

const SVIPUSERINFO_KEY = 'React-ts-ant-svipUserInfo';

const localSvipUserInfo = LocalStore.getValue<SvipUserInfoProps>(SVIPUSERINFO_KEY) || {};

export const defaults: SvipUserInfoProps = {
  growthValue: 0,
  headImg: '',
  levelLogoUrl: '',
  rechargeAmount: 0,
  state: 0,
  svipLevel: 0,
  userId: 0,
  userName: '',
  ...localSvipUserInfo
};

const SVIP_USERINFO_KEY = 'React-ts-ant-SVIPUSERINFO';

export const updateSvipUserInfos: (svipUserInfos: SvipUserInfoProps) => IAction<SvipUserInfoProps> = (
  svipUserInfos: SvipUserInfoProps
) => ({
  type: SVIP_USERINFO_KEY,
  payload: svipUserInfos
});

const svipUserInfoReducer: Reducer<SvipUserInfoProps, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case SVIP_USERINFO_KEY:
      LocalStore.setValue(SVIPUSERINFO_KEY, payload as SvipUserInfoProps);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default svipUserInfoReducer;
